<div class="merchant-layout">

  <!-- ================= MOBILE TOPBAR ================= -->
  <header class="mobile-topbar">

    <div class="mobile-brand">
      <h2>Weddingly</h2>
      <span>Merchant Panel</span>
    </div>

    <button
      class="menu-btn"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Toggle menu">

      <span class="material-symbols-outlined">
        {{ isSidebarOpen ? 'close' : 'menu' }}
      </span>

    </button>

  </header>


  <!-- ================= SIDEBAR OVERLAY ================= -->
  <div
    class="sidebar-overlay"
    [class.show]="isSidebarOpen"
    (click)="closeSidebar()">
  </div>


  <!-- ================= SIDEBAR ================= -->
  <aside
    class="merchant-sidebar"
    [class.mobile-open]="isSidebarOpen">

    <!-- Brand -->
    <div class="brand">

      <h2>Weddingly</h2>

      <p>Merchant Panel</p>

      <!-- Mobile close button -->
      <button
        class="mobile-close-btn"
        type="button"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          close
        </span>

      </button>

    </div>


    <!-- Navigation -->
    <nav>

      <a
        routerLink="/merchant/dashboard"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          dashboard
        </span>

        <span class="nav-label">
          Dashboard
        </span>

      </a>


      <a
        routerLink="/merchant/services"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          storefront
        </span>

        <span class="nav-label">
          Services
        </span>

      </a>


      <a
        routerLink="/merchant/portfolio"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          photo_library
        </span>

        <span class="nav-label">
          Portfolio
        </span>

      </a>


      <a
        routerLink="/merchant/enquiries"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          support_agent
        </span>

        <span class="nav-label">
          Enquiries
        </span>

        <span
          *ngIf="unreadEnquiriesCount > 0"
          class="notification-badge">

          {{ unreadEnquiriesCount }}

        </span>

      </a>


      <a
        routerLink="/merchant/leads"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          connect_without_contact
        </span>

        <span class="nav-label">
          Leads
        </span>

        <span class="pro-badge">
          PRO
        </span>

      </a>


      <a
        routerLink="/merchant/calendar"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          calendar_month
        </span>

        <span class="nav-label">
          Calendar
        </span>

      </a>


      <a
        routerLink="/merchant/bookings"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          event_note
        </span>

        <span class="nav-label">
          Bookings
        </span>

      </a>


      <a
        routerLink="/merchant/revenue"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          monitoring
        </span>

        <span class="nav-label">
          Revenue
        </span>

      </a>


      <a
        routerLink="/merchant/subscription"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          workspace_premium
        </span>

        <span class="nav-label">
          Subscription
        </span>

      </a>


      <a
        routerLink="/merchant/advertisement"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          campaign
        </span>

        <span class="nav-label">
          Advertisements
        </span>

        <span class="pro-badge">
          PRO
        </span>

      </a>


      <a
        routerLink="/merchant/about-us"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          business
        </span>

        <span class="nav-label">
          About Us
        </span>

      </a>


      <a
        routerLink="/merchant/profile"
        routerLinkActive="active"
        (click)="closeSidebar()">

        <span class="material-symbols-outlined">
          person
        </span>

        <span class="nav-label">
          My Profile
        </span>

      </a>

    </nav>


    <!-- Logout -->
    <button
      class="logout-btn"
      type="button"
      (click)="logout()">

      <span class="material-symbols-outlined">
        logout
      </span>

      Logout

    </button>

  </aside>


  <!-- ================= CONTENT ================= -->
  <main class="merchant-content">

    <router-outlet></router-outlet>

  </main>

</div>